module.exports = require('./dist/src/experimental/firebase-service');
